import React, { useId } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export function Input({
  label,
  error,
  helperText,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || useId();
  return <div className="w-full" data-id="element-184">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-185">
          {label}
        </label>}
      <input id={inputId} className={`
          flex w-full rounded-lg border bg-white px-3 py-3 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 disabled:cursor-not-allowed disabled:opacity-50
          ${error ? 'border-red-500 focus-visible:ring-red-500' : 'border-slate-200'}
          ${className}
        `} {...props} data-id="element-186" />
      {helperText && !error && <p className="mt-1.5 text-xs text-slate-500" data-id="element-187">{helperText}</p>}
      {error && <p className="mt-1.5 text-xs font-medium text-red-500" data-id="element-188">{error}</p>}
    </div>;
}